import { useProductRoleLabels } from "@/role/roleUtils"
import { ProductRole } from "@/role/__generated__/UpdateProductRoleButtonFragment.graphql"
import { DiscoIcon, SelectOption } from "@disco-ui"
import DiscoTableFilterDropdown from "@disco-ui/table/header/search/DiscoTableFilterDropdown"
import { TestIDProps } from "@utils/typeUtils"

type ProductMembersListPageRoleOption = SelectOption<ProductRole | null>

export type ProductMembersListPageRoleFilterState = {
  selectedRole: ProductMembersListPageRoleOption | null
}

interface ProductMembersListPageRoleFilterProps extends TestIDProps {
  filterState: ProductMembersListPageRoleFilterState
  setFilterState: (state: ProductMembersListPageRoleFilterState) => void
}

function ProductMembersListPageRoleFilter({
  filterState,
  setFilterState,
}: ProductMembersListPageRoleFilterProps) {
  const { manager, instructor, member } = useProductRoleLabels()

  const options: ProductMembersListPageRoleOption[] = [
    {
      value: null,
      title: "All Roles",
    },
    {
      value: "manager",
      title: manager.plural,
    },
    {
      value: "instructor",
      title: instructor.plural,
    },
    {
      value: "member",
      title: member.plural,
    },
  ]

  return (
    <DiscoTableFilterDropdown
      testid={"ProductMembersListPage.role-select"}
      isNested
      options={options}
      onOptionSelect={(selectedRole) => setFilterState({ selectedRole })}
      selectedOption={filterState.selectedRole}
      dropdown={{
        icon: <DiscoIcon icon={"user"} />,
        label: "Role",
      }}
    />
  )
}

export default ProductMembersListPageRoleFilter
